<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="indexName"
  >
    <global-search v-if="searchType === 'global'" />
    <posts-search v-if="searchType !== 'global'" />
  </ais-instant-search>
</template>

<script>
/* Packages */
import algoliasearch from 'algoliasearch/lite';

/* Components */
import { AisInstantSearch } from 'vue-instantsearch/vue3/es';
import GlobalSearch from './GlobalSearch/Main.vue';
import PostsSearch from './PostsSearch/Main.vue';

export default {
  name: 'AlgoliaSearch',
  components: {
    AisInstantSearch,
    GlobalSearch,
    PostsSearch,
  },
  provide() {
    return {
      searchType: this.searchType,
    };
  },
  props: {
    appId: {
      type: String,
      required: true,
    },
    indexName: {
      type: String,
      required: true,
    },
    searchKey: {
      type: String,
      required: true,
    },
    searchType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchClient: algoliasearch(
        this.appId,
        this.searchKey
      ),
    };
  },
};
</script>
